import axios from 'axios';
import { API_URL } from '../../../config/api';

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json',
  };
};

export const fetchVaultItems = async () => {
  const response = await axios.get(`${API_URL}/vault`, { headers: getHeaders() });
  return Array.isArray(response.data) ? response.data : [];
};

export const createVaultItem = async (payload) => {
  const response = await axios.post(`${API_URL}/vault`, payload, { headers: getHeaders() });
  return response.data;
};

export const deleteVaultItem = async (id) => {
  const response = await axios.delete(`${API_URL}/vault/${id}`, { headers: getHeaders() });
  return response.data;
};
